import cx from 'classnames'
import React from 'react'
import Toggle from 'react-toggle'

import styles from 'styles/components/Toggle.styl'

function ToggleCmp({ className, style, actions, ...props }) {
  return (
    <div className={cx(styles.Toggle, className)} style={style}>
      <Toggle
        icons={{
          checked: null,
          unchecked: null,
        }}
        {...props}
      />
    </div>
  )
}
ToggleCmp.displayName = 'Toggle'

export default ToggleCmp



// WEBPACK FOOTER //
// ./src/scripts/components/Toggle.js